// Visual styling for annotation categories — colour + label + underline pattern
// so categories never rely on colour alone.

export function decorationFor(pattern) {
  switch (pattern) {
    case 'Solid underline':
      return { textDecorationLine: 'underline', textDecorationStyle: 'solid', textDecorationThickness: '2px' };
    case 'Double underline':
      return { textDecorationLine: 'underline', textDecorationStyle: 'double' };
    case 'Dotted underline':
      return { textDecorationLine: 'underline', textDecorationStyle: 'dotted', textDecorationThickness: '2px' };
    case 'Wavy underline':
      return { textDecorationLine: 'underline', textDecorationStyle: 'wavy' };
    case 'Thick underline':
      return { textDecorationLine: 'underline', textDecorationStyle: 'solid', textDecorationThickness: '4px' };
    case 'Strikethrough preview':
      return { textDecorationLine: 'line-through', textDecorationStyle: 'solid' };
    default:
      return {};
  }
}

export function tokenStyleFor(cat) {
  if (!cat) return {};
  return {
    backgroundColor: cat.background_hex,
    color: cat.text_hex,
    textDecorationColor: cat.border_hex,
    ...decorationFor(cat.accessibility_pattern),
  };
}
